import React from "react";
import { Link } from "react-router-dom";
import { Instagram, Mail, MapPin } from "lucide-react";

export default function Footer() {
    return (
        <footer
            data-testid="site-footer"
            className="border-t border-white/10 bg-[#0a0a0a] mt-32"
        >
            <div className="px-6 md:px-12 lg:px-24 py-16 grid grid-cols-1 md:grid-cols-4 gap-12">
                <div className="md:col-span-2">
                    <div className="font-serif-display text-3xl">
                        paul<span className="text-[#c5a059]">.</span>mv07
                    </div>
                    <p className="text-zinc-500 mt-4 max-w-md leading-relaxed">
                        Photographe automobile et lifestyle. Mariages, baptêmes,
                        portraits, shootings sur mesure — chaque cliché raconte
                        une histoire.
                    </p>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-4">
                        Navigation
                    </div>
                    <ul className="space-y-2 text-zinc-300">
                        <li><Link to="/galerie" className="hover:text-[#c5a059]">Galeries</Link></li>
                        <li><Link to="/a-propos" className="hover:text-[#c5a059]">À propos</Link></li>
                        <li><Link to="/tarifs" className="hover:text-[#c5a059]">Tarifs</Link></li>
                        <li><Link to="/temoignages" className="hover:text-[#c5a059]">Témoignages</Link></li>
                        <li><Link to="/contact" className="hover:text-[#c5a059]">Contact</Link></li>
                    </ul>
                </div>

                <div>
                    <div className="text-xs uppercase tracking-[0.25em] text-zinc-500 mb-4">
                        Contact
                    </div>
                    <ul className="space-y-3 text-zinc-300 text-sm">
                        <li className="flex items-center gap-3">
                            <Mail size={16} strokeWidth={1.5} className="text-[#c5a059]" />
                            paulmoisson76@gmail.com
                        </li>
                        <li className="flex items-center gap-3">
                            <Instagram size={16} strokeWidth={1.5} className="text-[#c5a059]" />
                            @paul.mv07
                        </li>
                        <li className="flex items-center gap-3">
                            <MapPin size={16} strokeWidth={1.5} className="text-[#c5a059]" />
                            France
                        </li>
                    </ul>
                </div>
            </div>

            <div className="border-t border-white/5 px-6 md:px-12 lg:px-24 py-6 flex flex-col md:flex-row justify-between text-xs text-zinc-600">
                <span>© {new Date().getFullYear()} paul.mv07 photography — Tous droits réservés.</span>
                <Link to="/admin/login" data-testid="footer-admin-link" className="hover:text-[#c5a059] mt-2 md:mt-0">
                    Espace admin
                </Link>
            </div>
        </footer>
    );
}
